import type { InternalAxiosRequestConfig } from 'axios'

export const beforeSend = (
  config: InternalAxiosRequestConfig,
): InternalAxiosRequestConfig => {
  // eslint-disable-next-line no-restricted-syntax
  const token = localStorage.getItem('accessToken') || ''

  if (token.length > 0 && config.headers) {
    config.headers.authorization = `Bearer ${token}`
  }

  return config
}
